import { Box, Typography } from '@mui/material';
import {GaugeType} from "types/dashboard.ts";

export const WhiteCircleInfo = ({ value, background, gaugeType }: { value: string, background: boolean, gaugeType: GaugeType }) => {
    const formattedValue = gaugeType === GaugeType.Chrono ? formatChronosValue(value) : value;

    return (
        <Box
            sx={{
                width: '6.25rem',
                height: '6.25rem',
                mt: '20%',
                borderRadius: '50%',
                backgroundColor: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                zIndex: 0,
                overflow: 'hidden',
                border: '2px solid #FFFFFF',
                boxShadow: !background ? '0px -5px 5px rgba(0, 0, 0, 0.2), 5px 0px 5px rgba(0, 0, 0, 0.2), -5px 0px 5px rgba(0, 0, 0, 0.2)' : null
            }}>
            {gaugeType === GaugeType.None && (
                <Box />
            )}

            <Typography
                variant="headlineLarge"
                sx={{
                    lineHeight: '2.8rem',
                    textAlign: 'center',
                    color: 'primary.main',
                    zIndex: 2,
                }}
            >
                {formattedValue}
                {gaugeType === GaugeType.Chrono && (
                    <span style={{
                        position: 'absolute',
                        fontSize: '1rem',
                        top: '55%',
                        left: getUnit(value)  === 'min' ? '37%' : '32%',
                    }}>{getUnit(value)}</span>
                )}
            </Typography>
        </Box>
    );
};

const formatChronosValue = (value: string): string => {
    if(value == "- - -") return "--:--"
    const [minutes] = value.split(':').map(Number);
    if (minutes >= 60) {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        return `${hours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}`;
    }
    return value;
};

const getUnit = (value: string): string => {
    return value == "- - -" ? 'min' : 'heure';
};